import { useState } from "react";

import {
  useCancelSubscription,
  useCreateCustomerPortal,
  useRenewSubscription,
} from "@/queries/organizations";

interface UseSubscriptionActionsProps {
  canceledAt?: string | null;
  isCanceled: boolean;
}

export const useSubscriptionActions = ({ canceledAt, isCanceled }: UseSubscriptionActionsProps) => {
  const [showPricingModal, setShowPricingModal] = useState(false);

  const { mutate: createCustomerPortal, isLoading: isLoadingCreateCustomerPortal } =
    useCreateCustomerPortal();

  const { mutate: renewSubscription } = useRenewSubscription();

  const { mutate: cancelSubscription, isLoading: isLoadingCancelSubscription } =
    useCancelSubscription();

  const handleManageBilling = () => {
    if (canceledAt && !isCanceled) {
      renewSubscription();
    } else {
      createCustomerPortal(
        { return_url: window.location.href },
        {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onSuccess: (result: any) => {
            window.open(result.portal_session_url);
          },
        },
      );
    }
  };

  return {
    cancelSubscription,
    isLoadingCancelSubscription,
    handleManageBilling,
    isLoadingCreateCustomerPortal,
    showPricingModal,
    setShowPricingModal,
  };
};
